<script>
export default {
	props: ["lat", "lng", "mapinfo"],
	name: "google-map",
	data() {
		return {
			showInfoWindow: false
		};
	},
	methods: {
		toggleInfoWindow() {
			this.showInfoWindow = !this.showInfoWindow;
		}
	}
};
</script>

<template>
    <div>
        <transition appear name="fade">
            <GmapMap 
                :center="{lat:lat, lng:lng}"
                :zoom="10"
                style="width: 100%; height: 300px"
            >
                <GmapMarker            
                    :position="{lat:lat, lng:lng}"
                    icon='/images/map-pointer-fira.png'
                    @click="toggleInfoWindow"
                >
                    <GmapInfoWindow :opened="showInfoWindow" v-if="mapinfo">
                        <div v-html="mapinfo"></div>
                    </GmapInfoWindow>
                </GmapMarker>
            </GmapMap>
        </transition>
    </div>
</template>

<style lang="less">
    .vue-map-container {
        * { 
            border-style: none; 
        }
    }
</style>
